import React from 'react'

import styles from './styles/supplier_tricks_simple_component.module.scss'
import { HtmlContent } from 'utils'

const SupplierTricksSimpleComponent = ({ title, description, tricks }) => {
  return (
    <section className={styles.supplier_tricks_simple}>
      <div className={styles.supplier_tricks_simple__outer}>
        <h2 className={styles.supplier_tricks_simple__title}>{title}</h2>
        <HtmlContent 
          content={description} 
          className={styles.supplier_tricks_simple__description} 
        />
      </div>
      <ul className={styles.supplier_tricks_simple__list}>
        {tricks.map((item) => (
          <li key={item.id} className={styles.supplier_tricks_simple__item}>
            <div className={styles.supplier_tricks_simple__item_top}>
              <img loading="lazy"
                alt=''
                src={item.icon}
                className={styles.supplier_tricks_simple__item_icon}
              />
              <div className={styles.supplier_tricks_simple__item_text}>
                <div className={styles.supplier_tricks_simple__item_text_title}>
                  {item.title}
                </div>
                <p className={styles.supplier_tricks_simple__item_text_description}>{item.subtitle}</p>
              </div>
            </div>
            <HtmlContent content={item.description} className={styles.supplier_tricks_simple__item_bottom} />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default SupplierTricksSimpleComponent